export default __webpack_public_path__ + "static/aikido-klemen-b0db70fe1bb0457497ba7f8f3051d6a4.jpg";